import React, { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./Footer.module.css";

const Footer: FC = () => (
  <footer className="bg-dark text-light py-4">
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto" className="text-center">
          <div className="mb-3">
            <a
              href="https://linkedin.com/company/tamarillodata"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-light mx-2 ${styles.socialIcon}`}
            >
              LinkedIn
            </a>
          </div>
          <p className="mb-0">© {new Date().getFullYear()} Tamarillo</p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
